import Vue from "vue";
import Vuex from "vuex";

import { initializeModules } from "@/plugins/store-accessors";

import index from "./indexPage";
import cart from "./cart/cart";
import common from "./common";
import personal from "./personal";
import product from "./product";
import catalog from "./catalog/catalog";
import orders from "./account/orders";
import contacts from "./contacts";
import notifications from "./notifications";
import prices from "./prices";
import complaints from "./complaints";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    cart,
    index,
    common,
    personal,
    catalog,
    product,
    contacts,
    notifications,
    prices,
    complaints,
    account: {
      namespaced: true,
      modules: {
        orders,
      },
    },
  },
});

Vue.use(initializeModules, { store });

export default store;
